module.exports = __webpack_public_path__ + "static/media/526SunsetAveNW_2018-06-06_60.57244909.jpg";